/**
 * @namespace dashboard
 */
import { concatAll } from '~/utils/lib/core/prelude'

export const getMainRoute = (
  /** @type {import('~/stores/client/access').Structure["id"]} */ structure_id,
  /** @type {import('~/stores/client/access').Company["code_societe"]} */ code_societe = '',
) => concatAll([
  `/data/${structure_id}`,
  `/dashboard`,
  `?company=${encodeURIComponent(code_societe)}`
])
